module.exports = __webpack_public_path__ + "img/risk-volumes.e3588402.png";